import { ResponsivePie } from '@nivo/pie'
import { useGenreStats } from './useGenreStats'

export const GenreStatsPie = ({ inView }: { inView: boolean }) => {
  const stats = useGenreStats()

  return (
    <ResponsivePie
      data={inView ? stats : []}
      colors={({ data }) => data.color}
      innerRadius={0.8}
      startAngle={-180}
      endAngle={180}
      padAngle={1}
      cornerRadius={2}
      enableArcLinkLabels={false}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsThickness={2}
      enableArcLabels={false}
      arcLabelsSkipAngle={10}
      legends={[]}
      isInteractive={false}
      transitionMode="startAngle"
      motionConfig="slow"
    />
  )
}
